/**
 * @fileoverview Entity Picker type tab presentation component
 */

goog.declareModuleId('yext.ui.components.entitypicker.tab');
import {hasManaUITheme} from '/ui/design/hasManaUITheme';
import {classNames} from '/ui/lib/classnames';

import * as styles from '/ui/components/entitypicker/tabs/tabs.module.scss';

export function Tab(props) {
  const selected = props.id === props.selectedTab;
  let buttonCssClass = 'uep-tab-button';
  buttonCssClass += selected ? ' uep-tab-selected' : '';

  if (hasManaUITheme()) {
    buttonCssClass = classNames(styles.uepTypeTab, {
      [styles.uepTypeTabSelected]: selected,
    });
  }

  return (
    <button type="button" className={buttonCssClass} onClick={() => props.selectHandler(props.id)} aria-controls={props.id} aria-expanded={selected}>
      {props.children}
    </button>
  );
}
